import { parseArrayFromString } from '../../_common/client/parse-array-from-string';
import { getSessionStorage } from '../../_common/client/session-storage';
import { DimensionValueByType } from '../shared-types';

export const getCurrentDimensionsForDimensionStateEvent = (
    originalDimensionValues: DimensionValueByType[],
    selectedDimensionValues: DimensionValueByType[],
    productId: string | null
): DimensionValueByType[] => {
    const sessionStorage = getSessionStorage();
    sessionStorage.getItem(`ft5-dimension-selection-priority-for-product-${productId}`);
    const result = [...selectedDimensionValues];
    for (const originalDimensionValue of originalDimensionValues) {
        if (result.some(resultEntry => resultEntry.type === originalDimensionValue.type)) continue;
        result.push(originalDimensionValue);
    }
    const dimensionSelectionPriority = getDimensionSelectionPriorityFromSessionStorage(productId);
    if (dimensionSelectionPriority) {
        sortByPriority(result, dimensionSelectionPriority);
    }
    return result;
};

const sortByPriority = (dimensionList: DimensionValueByType[], dimensionSelectionPriority: string[]) => {
    dimensionList.sort((oneResultEntry, anotherResultEntry) => {
        const indexOfFirst = dimensionSelectionPriority.indexOf(oneResultEntry.type);
        const indexOfSecond = dimensionSelectionPriority.indexOf(anotherResultEntry.type);
        if (indexOfFirst === -1 && indexOfSecond === -1) {
            // both are not in priority list
            return 0;
        }
        if (indexOfFirst === -1 && indexOfSecond >= 0) {
            // first is not in priority list, second is
            return 1;
        }
        if (indexOfFirst >= 0 && indexOfSecond === -1) {
            // first is in priority list, second is not
            return -1;
        }
        // both are in priority list
        return indexOfFirst - indexOfSecond;
    });
};

const getDimensionSelectionPriorityFromSessionStorage = (productId: string | null): string[] | void => {
    const sessionStorage = getSessionStorage();
    if (productId == null) return;
    const storageEntry = sessionStorage.getItem(`ft5-dimension-selection-priority-for-product-${productId}`);
    if (storageEntry == null) return;
    return parseArrayFromString(storageEntry);
};
